import React from "react";
import Country, { CountryPropsType } from "../country";

interface NationalityType {
  value: string;
  dataPath: string;
  onSelectCallback?: CountryPropsType["onSelectCallback"];
}
export default function Nationality({
  value,
  dataPath = "",
  onSelectCallback,
}: NationalityType): React.JSX.Element {
  const country = { alpha2: value };

  return (
    <Country
      dataPath={dataPath}
      value={country}
      asNationality={true}
      onSelectCallback={onSelectCallback}
    />
  );
}
